export { default as Header } from './Header';
export { default as Footer } from './Footer';
export { default as Swiper } from './Swiper';
export { default as Feedback } from './Feedback';
export { default as FeedbackForm } from './FeedbackForm';

export { default as CardsSection } from './CardsSection';
export { default as NewsSection } from './NewsSection';
export { default as MetaList } from './MetaList';
export { default as Popup } from './Popup';
export { default as CookieInfo } from './CookieInfo';

export { default as SaitesSection } from './SaitesSection';



// WEBPACK FOOTER //
// ./src/modules/index.js